export default "__VITE_ASSET__BhBdmEO0__"